import React, { useEffect, useRef } from "react"
import styled, { keyframes } from "styled-components"
import { rem } from "polished"
import InlineSVG from "react-inlinesvg"

// import { ReactComponent as Logos }from "../../assets/images/clients.svg"

const Slide = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`

const El = styled.div`
  margin-top: ${rem(250)};
  margin-bottom: ${rem(200)};

  @media ${props => props.theme.desktopDown} {
    margin-top: ${rem(150)};
    margin-bottom: ${rem(150)};
  }

  @media ${props => props.theme.mobileDown} {
    margin-top: ${rem(80)};
    margin-bottom: ${rem(80)};
  }
`

const LogosLine = styled.div`
  width: 100%;
  display: flex;
  animation: 50s ${Slide} linear infinite;

  svg {
    width: 50%;
    height: auto;
    fill: #c6c5c6;
    align-self: flex-start;
  }

  @media ${props => props.theme.desktopDown} {
    width: 125%;
  }

  @media ${props => props.theme.mobileDown} {
    width: 200%;
  }
`

const LogosLineOutter = styled.div`
  width: 600%;
  display: block;

  &:nth-of-type(2) {
    position: relative;
    left: -100%;

    ${LogosLine} {
      animation: 50s ${Slide} linear infinite reverse;
    }
  }
`

const Heading = styled.div`
  color: #ff2400;
  dispaly: block;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: ${rem(40)};

  @media ${props => props.theme.mobileDown} {
    margin-bottom: ${rem(10)};
    font-size: ${rem(14)};
  }
`

const ClientsSlider = props => {
  const ElRef = useRef(null)
  const LineRef1 = useRef(null)
  const LineRef2 = useRef(null)

  const sectionScroll = () => {
    var viewportHeight = window.innerHeight
    // var viewportTopX = window.scrollY;
    // var viewportTopX = window.scrollbar.offset.y;

    var viewportTopX = window.scrollY

    var viewportBottomX = viewportTopX + viewportHeight
    var elementHeight = ElRef.current.offsetHeight
    var elementTopX = ElRef.current.offsetTop
    // var elementBottomX = elementTopX + elementHeight;

    var percentage =
      (viewportBottomX - elementTopX) / (viewportHeight + elementHeight)

    let amountToTransform = window.innerWidth / 2

    // LineRef1.current.style.transform = "translateX("+ -amountToTransform*percentage +"px)"
    // LineRef2.current.style.transform = "translateX(-"+ ((2*window.innerWidth) - (amountToTransform*percentage)) + "px)"

    LineRef1.current.style.transform =
      "translateX(" + amountToTransform * percentage + "px)"
    LineRef2.current.style.transform =
      "translateX(-" + amountToTransform * percentage + "px)"
  }

  useEffect(() => {
    window.addEventListener("scroll", sectionScroll)

    return () => {
      window.removeEventListener("scroll", sectionScroll)
    }
  }, [])

  return (
    <El ref={ElRef}>
      <Heading>clients</Heading>

      <LogosLineOutter ref={LineRef1}>
        <LogosLine>
          <InlineSVG src={props.logoTop} />
          <InlineSVG src={props.logoTop} />
        </LogosLine>
      </LogosLineOutter>

      <LogosLineOutter ref={LineRef2}>
        <LogosLine>
          <InlineSVG src={props.logoBottom} />
          <InlineSVG src={props.logoBottom} />
        </LogosLine>
      </LogosLineOutter>
    </El>
  )
}

export default ClientsSlider
